import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';   // plugin oficial
import LanguageDetector from 'i18next-browser-languagedetector';
import LocalStorage from 'utils/LocalStorage';
import enUS from './en';
import esES from './es';

i18next
  .use(initReactI18next)          // ← recomendable
  .use(LanguageDetector)
  .init({
    resources: {
      en: { cnig: enUS },
      es: { cnig: esES },
    },
    lng: LocalStorage.getString('language') || 'es',
    fallbackLng: 'es',
    debug: false,
    defaultNS: 'cnig',
    keySeparator: '.',
    returnObjects: true,
    interpolation: { escapeValue: false, formatSeparator: ',' },
    // react: { useSuspense: false }, // si lo necesitas
    detection: { lookupQuerystring: 'lang' },
  });

export default i18next;
